import React from 'react';
import { getClient, getQuery } from '@src/utils/index';
import auth from '@ifeng/ui_pc_auth';
import { Grounds } from '@ifeng/client_grounds';
import { toweixinLogin, getUserInfo } from '@src/services/api';
import { cookie } from '@ifeng/ui_base';
import { LoginUrl } from '@src/constants/index';

const useLogin = () => {
    const { code } = getQuery();
    const clientType = getClient();
    const gotoLogin = async ({ otherLogin = false, sinaLogin = true, openShare = false }) => {
        if (clientType === 'weibo') {
            // 登录
            if (!auth.isLogin()) {
                if (sinaLogin) {
                    const openUrl = window.location.href.indexOf('?') > -1 ? `${window.location.href}&openShare=true` : `${window.location.href}?openShare=true`;
                    const callbackUrl = openShare ? encodeURIComponent(`${openUrl}`) : encodeURIComponent(window.location.href);

                    window.location.replace(`https://api.weibo.com/oauth2/authorize?client_id=1073104718&redirect_uri=http://id.ifeng.com/callback/sina?callback=${callbackUrl}&response_type=code`);
                }
            }
        } else if (clientType === 'weixin') {
            if (!code) {
                if (!(cookie.get('sid') && cookie.get('sid') !== 'undefined')) {
                    const callback = encodeURIComponent(`https://id.ifeng.com/sso/v1/?redirect=${encodeURIComponent(window.location.href)}`);

                    window.location.replace(
                        `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9bd3b38f9c278ab4&redirect_uri=${callback}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
                    );
                }
            } else {
                // 用code进行登录
                const data = await toweixinLogin(code);

                if (data?.code === 200 && data?.data?.token) {
                    cookie.set('sid', data?.data?.token || '', '/', '.ifeng.com');
                }
            }
        } else if (clientType === 'native') {
            if (!Grounds.userIsLogin()) {
                Grounds.userLogin();
            }
        } else if (otherLogin) {
            if (!(cookie.get('sid') && cookie.get('sid') !== 'undefined')) {
                window.location.replace(`${LoginUrl}?cb=${window.location.href}`);
            }
        }
    };

    const otherLogin = () => {
        window.location.replace(`${LoginUrl}?cb=${window.location.href}`);
    };

    const isLogin = () => {
        if (clientType === 'native') {
            return Grounds.userIsLogin();
        } else {
            return cookie.get('sid') && cookie.get('sid') !== 'undefined';
        }
    };

    const canClick = () => {
        if (clientType === 'native' || clientType === 'weixin' || clientType === 'weibo') {
            return true;
        } else {
            return false;
        }
    };

    return { canClick, isLogin, gotoLogin, otherLogin };
};

export default useLogin;
